<br /><br /><br /><br />
<div class="page-title">
  <h1 class="title-text">First-Aid Report</h1>
  <p class="form-desc"></p>
</div>
<br />

<mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
  <mat-card-content>
    <!-- Progress Tracker -->
    <mat-progress-bar mode="determinate" [value]="calculateProgress()"></mat-progress-bar>
    <div class="progress-status" style="display: flex; justify-content: space-between; margin-top: 16px;">
      <div style="text-align: center; width: 100%;">
        Employee
        <br />
        @if (form.value?.employeeReport.reporterCompleted) {
          <span style="color: green;">Completed</span>
        }
        @if (!form.value?.employeeReport.reporterCompleted) {
          <span style="color: gray;">Pending</span>
        }
      </div>
      <div style="text-align: center; width: 100%;">
        Safety Director
        <br />
        @if (form.value?.safetyDirectorReview.safetyDirectorCompleted) {
          <span style="color: green;">Completed</span>
        }
        @if (!form.value?.safetyDirectorReview.safetyDirectorCompleted) {
          <span style="color: gray;">Pending</span>
        }
      </div>
    </div>
    <br />

    <div class="sections">
      <mat-accordion multi="true">
        <!-- Section 1: First Aid Form Data -->
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Employee Report
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="form" (ngSubmit)="saveSection1()">
            <!-- Read-Only Mode -->
            @if (form.value?.employeeReport.reporterCompleted) {
              <p>Reporter Email: <span class="readonly">{{ form.value?.employeeReport.userEmail || 'N/A' }}</span></p>
              <p>Date of Report: <span class="readonly">{{ form.value?.employeeReport.dateOfReport | date: 'M/d/yyyy' : 'UTC' }}</span></p>
              <p>Time of Report: <span class="readonly">{{ form.value?.employeeReport.timeOfReport | date: 'h:mm a' : 'UTC' }}</span></p>
              <p>Incident Location: <span class="readonly">{{ form.value?.employeeReport.incidentLocation || 'N/A' }}</span></p>
              <p>First-Aid Responder: <span class="readonly">{{ form.value?.employeeReport.firstAidResponder || 'N/A' }}</span></p>
              <p>First-Aid Provided To: <span class="readonly">{{ form.value?.employeeReport.firstAidProvidedTo || 'N/A' }}</span></p>
              <p>Type of First-Aid Administered: <span class="readonly">{{ form.value?.employeeReport.typeOfFirstAid || 'N/A' }}</span></p>
              <p>Why First-Aid Was Necessary: <span class="readonly">{{ form.value?.employeeReport.whyFirstAidNecessary || 'N/A' }}</span></p>
              <p>Date Report Submitted: <span class="readonly">{{ form.value?.employeeReport.dateReportSubmitted | date: 'M/d/yyyy' : 'UTC' }}</span></p>
              <p>Reporter Signature: <span class="readonly">{{ form.value?.employeeReport.reporterSignature || 'N/A' }}</span></p>
            } @else {
              <div formGroupName="employeeReport">
                <mat-form-field appearance="fill">
                  <mat-label>Your Email:</mat-label>
                  <input matInput placeholder="Enter email" formControlName="userEmail" required/>
                </mat-form-field>
                <br /><br />
                <div class="form-row">
                  <mat-form-field appearance="fill">
                    <mat-label>Date first-aid provided:</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="dateOfReport" required/>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Time first-aid provided:</mat-label>
                    <input matInput [matTimepicker]="timePicker" formControlName="timeOfReport" required>
                    <mat-timepicker-toggle matIconSuffix [for]="timePicker"/>
                    <mat-timepicker #timePicker/>
                  </mat-form-field>
                </div>
                <mat-form-field appearance="fill">
                  <mat-label>Location of first-aid:</mat-label>
                  <input matInput formControlName="incidentLocation" placeholder="Enter the location of the incident" required/>
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>First-aid responder:</mat-label>
                  <input matInput formControlName="firstAidResponder" placeholder="Name of the first-aid responder" required/>
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>First-aid provided to:</mat-label>
                  <input matInput formControlName="firstAidProvidedTo" placeholder="Name of the person to whom first-aid was provided" required/>
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Type of first-aid administered: (5000 characters max)</mat-label>
                  <textarea matInput placeholder="Describe the type of first-aid administered" formControlName="typeOfFirstAid" rows="10"></textarea>
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Why was first-aid necessary: (5000 characters max)</mat-label>
                  <textarea matInput placeholder="Describe why first-aid was necessary" formControlName="whyFirstAidNecessary" rows="10"></textarea>
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Date report was completed and submitted to Safety Office:</mat-label>
                  <input matInput [matDatepicker]="picker2" formControlName="dateReportSubmitted" required/>
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Signature of Report Provider:</mat-label>
                  <input matInput formControlName="reporterSignature" placeholder="Report Provider Signature" required/>
                </mat-form-field>
                <div class="button-container">
                  <button mat-raised-button color="primary" class="submit-button" [disabled]="loadingSection1">Submit</button>
                </div>
                @if (loadingSection1) {
                  <div class="loading-spinner">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                }
                @if (!loadingSection1 && form.invalid && form.touched) {
                  <div class="error-message">
                    Please fill in all required fields.
                  </div>
                }
              </div>
            }

            <!-- Editable Mode -->
          </form>
        </mat-expansion-panel>

        <!-- Section 2: Safety Director Signature -->
        <mat-expansion-panel [expanded]="currentStep === 2 || form.value?.safetyDirectorReview.safetyDirectorCompleted">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Safety Director Review
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="form" (ngSubmit)="saveSection2()">
            <!-- Read-Only Mode -->
            @if (form.value?.safetyDirectorReview.safetyDirectorCompleted || !form.value?.employeeReport.reporterCompleted) {
              <p>Safety Director Signature: <span class="readonly">{{ form.value?.safetyDirectorReview.safetyDirectorSignature || 'N/A' }}</span></p>
            } @else {
              <div formGroupName="safetyDirectorReview">
                <mat-form-field appearance="fill">
                  <mat-label>Signature of Safety Director:</mat-label>
                  <input matInput formControlName="safetyDirectorSignature" placeholder="Safety Director Signature" required/>
                </mat-form-field>
                <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Complete Section</button>
                @if (loadingSection2) {
                  <div class="loading-spinner">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                }
              </div>
            }

            <!-- Editable Mode -->
          </form>
        </mat-expansion-panel>



      </mat-accordion>
    </div>

  </mat-card-content>
</mat-card>
<br><br>

<div class="page-title">
  <p class="form-desc-two">If form does not submit, ensure all required fields are answered. Additionally, depending on the network, the form submission may take a minute. If it still does not submit, reach out directly to <i class="contact">(pturner&#64;landpoint.net)</i> to get it handled. </p>
</div>
